<mgl-map #mapEl [mapStyle]="mapStyle()" [zoom]="mapZoom" [minZoom]="mapMinZoom" [maxZoom]="mapMaxZoom" [center]="mapCenter" (mapLoad)="onMapLoad($event)" (styleData)="onStyleData($event)"
  [bearing]="mapBearing" [pitchWithRotate]="true" [dragRotate]="true"
  [pixelRatio]="mapPixelRatio" [maxTileCacheSize]="mapMaxTileCacheSize" [attributionControl]="false"
  [transformRequest]="transformMapRequest">
</mgl-map>

<app-follow-mode [followModeState]="followModeState" (followModeOnClicked)="onFollowModeClicked()"></app-follow-mode>